/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CommonSettingsGet,
  CommonSettingsListParams,
  CompanySettingsGet,
  Smtp,
  UpdateCompanySettingsBody,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Settings<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags CommonSettings
   * @name CommonSettingsList
   * @summary Получить общие настройки
   * @request GET:/Settings/CommonSettings
   * @secure
   * @response `200` `CommonSettingsGet` Общие настройки
   */
  commonSettingsList = (query: CommonSettingsListParams, params: RequestParams = {}) =>
    this.request<CommonSettingsGet, any>({
      path: `/Settings/CommonSettings`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CommonSettings
   * @name UpdateCommonSettings
   * @summary Обновление общих настроек
   * @request POST:/Settings/CommonSettings
   * @secure
   * @response `200` `void` Success
   */
  updateCommonSettings = (data: CommonSettingsGet, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Settings/CommonSettings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CompanySettings
   * @name CompanySettingsDetail
   * @summary Получить настройку организации по идентификатору
   * @request GET:/Settings/CompanySettings/{id}
   * @secure
   * @response `200` `CompanySettingsGet` Настройки организации
   */
  companySettingsDetail = (id: string, params: RequestParams = {}) =>
    this.request<CompanySettingsGet, any>({
      path: `/Settings/CompanySettings/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CompanySettings
   * @name UpdateCompanySettings
   * @summary Обновление настройки организации
   * @request POST:/Settings/CompanySettings/{id}/update
   * @secure
   * @response `200` `void` Success
   */
  updateCompanySettings = (id: string, data: UpdateCompanySettingsBody, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Settings/CompanySettings/${id}/update`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CompanySettings
   * @name CheckSmtp
   * @request POST:/Settings/CompanySettings/checkSmtp
   * @secure
   * @response `200` `void` Success
   */
  checkSmtp = (data: Smtp, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Settings/CompanySettings/checkSmtp`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
